// Dev harness (/voice-test): exercise the hold-to-talk -> Whisper -> LLM
// interpretation pipeline with each expectation type.
import React, {useState} from "react";
import {HoldToTalk} from "./hold_to_talk";

const EXPECTS = ['free', 'name', 'number', 'choice'];
const DEFAULT_CONTEXT = {
    name: 'Candidate names: Maya, Dev, Priya, Tomas, Jules, Anika, Sam, Rosa',
    choice: 'Options: GIVE points away, or TAKE points from someone else',
    number: '',
    free: '',
};

export const VoiceTest = () => {
    const [expect, setExpect] = useState('free');
    const [context, setContext] = useState('');
    const [results, setResults] = useState([]);

    const pick = (ex) => {
        setExpect(ex);
        setContext(DEFAULT_CONTEXT[ex]);
    };

    return <div style={{
        position: 'fixed', inset: 0, backgroundColor: 'black', color: 'white',
        display: 'flex', flexDirection: 'column', alignItems: 'center',
        gap: 20, padding: '40px 20px', overflowY: 'auto',
    }}>
        <div style={{fontSize: 13, fontWeight: 800, letterSpacing: 4, textTransform: 'uppercase', opacity: 0.5}}>
            Voice Pipeline Test
        </div>
        <div style={{display: 'flex', gap: 8}}>
            {EXPECTS.map(ex => <button key={ex} onClick={() => pick(ex)} style={{
                padding: '8px 16px', borderRadius: 6, fontFamily: 'inherit', fontWeight: 700, cursor: 'pointer',
                border: expect === ex ? '2px solid #f1d28b' : '2px solid #444',
                background: '#111', color: expect === ex ? '#f1d28b' : '#999',
            }}>{ex}</button>)}
        </div>
        <input
            value={context}
            onChange={(e) => setContext(e.target.value)}
            placeholder="context (optional)"
            style={{width: 500, maxWidth: '90vw', background: '#111', color: 'white', border: '1px solid #444', borderRadius: 6, padding: 10, fontSize: 15, fontFamily: 'inherit'}}
        />
        <HoldToTalk
            expect={expect}
            context={context}
            onResult={(r) => setResults(prev => [{...r, expect, at: new Date().toLocaleTimeString()}, ...prev])}
        />
        <div style={{width: 560, maxWidth: '92vw', display: 'flex', flexDirection: 'column', gap: 10}}>
            {results.map((r, i) => <div key={i} style={{
                padding: 12, borderRadius: 8, background: '#101010',
                border: `1px solid ${r.answered ? 'rgba(46,204,64,0.6)' : 'rgba(255,90,60,0.6)'}`,
                fontSize: 15,
            }}>
                <div style={{opacity: 0.55, fontSize: 12}}>{r.at} · expect: {r.expect}</div>
                <div style={{fontStyle: 'italic', opacity: 0.85}}>heard: "{r.transcript}"</div>
                <div style={{fontWeight: 800, color: r.answered ? '#7dff96' : '#ff9d8a'}}>
                    {r.answered ? `→ ${r.value}` : (r.micDenied ? 'mic denied' : 'not an answer')}
                </div>
            </div>)}
        </div>
    </div>;
};
